<div
  class="h-full flex flex-row min-w-0 border border-proffeo-border rounded-lg hover:border-proffeo-surface-off hover:shadow-md transition-all duration-200 overflow-hidden"
>
  <proffeo-file-item-thumbnail
    (click)="onPreview()"
    [file]="file()"
    [isAvatar]="isAvatar()"
    class="cursor-pointer h-28 w-42 max-sm:w-21 shrink-0"
  />

  <div class="flex flex-row items-center h-full w-full min-w-0 gap-1 p-2 justify-between relative">
    <!-- File Info -->
    <div class="flex flex-col h-full flex-1 min-w-0 gap-1 justify-between">
      @if (showTitle()) {
        <p
          [matTooltip]="$safeNavigationMigration(file()?.name)"
          class="text-proffeo-text text-sm line-clamp-1 group-hover:text-proffeo-accent-600 transition-colors"
        >
          {{ file()?.name }}
        </p>
      }
      <proffeo-file-description
        (descriptionChange)="onDescriptionChange($event)"
        [description]="$safeNavigationMigration(file()?.description)"
        class="block min-w-0 w-full"
      />

      <!-- User & Date -->
      <div class="items-center justify-between">
        <div class="flex items-center gap-2">
          <proffeo-avatar
            [user]="$safeNavigationMigration(file()?.createdBy())"
            [size]="avatarSize"
          ></proffeo-avatar>
          <span class="text-xs text-proffeo-muted">
            {{ $safeNavigationMigration(file()?.createdAt) | proffeoDate }}
          </span>
        </div>
        @if (showOverlay()) {
          <proffeo-file-item-actions
            (clickOutside)="showOverlay.set(false)"
            (mouseleave)="showOverlay.set(false)"
            (preview)="onPreview()"
            (delete)="onDelete()"
            (download)="onDownload()"
            (setAsAvatar)="onSetAsAvatar()"
            [file]="file()"
            [canSetAsAvatar]="canSetAsAvatar()"
            [isAvatar]="isAvatar()"
            proffeoClickedOutside
            class="absolute bottom-0 right-0 w-full"
          />
        }
      </div>
    </div>

    <mat-icon
      fontIcon="more_vert"
      click
      showOverlay
      set
      true
      class="cursor-pointer"
    />
  </div>
</div>
